"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalisePhoneNumber = exports.getPhoneValidationErrors = exports.emailErrors = exports.getEmailValidationErrors = void 0;
function getEmailValidationErrors(_a) {
    var email = _a.email, confirmEmail = _a.confirmEmail;
    var errors = [];
    if (confirmEmail != null) {
        errors = __spreadArray(__spreadArray([], __read(errors), false), __read(emailErrors({ confirmEmail: confirmEmail, email: email })), false);
    }
    return errors;
}
exports.getEmailValidationErrors = getEmailValidationErrors;
// As defined by https://github.com/ovotech/identity-admin/blob/master/api-docs/identity-admin.raml
// eslint-disable-next-line no-useless-escape
var isValidEmailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
function emailErrors(_a) {
    var email = _a.email, confirmEmail = _a.confirmEmail;
    var errors = [];
    if (!isValidEmailRegex.test(email)) {
        errors.push({
            id: 'email',
            message: 'EMAIL_INVALID',
        });
    }
    else if (email !== confirmEmail) {
        errors.push({
            id: 'confirmEmail',
            message: 'EMAILS_MUST_MATCH',
        });
    }
    return errors;
}
exports.emailErrors = emailErrors;
var isValidPhoneNumberRegex = /^\+\d{11,15}$/;
function getPhoneValidationErrors(phoneNumbers) {
    var normalisedPhoneNumbers = phoneNumbers.map(normalisePhoneNumber);
    return normalisedPhoneNumbers.reduce(function (result, phoneNumber, index) {
        if (!isValidPhoneNumberRegex.test(phoneNumber)) {
            result.push({
                id: "phoneNumber-".concat(index),
                message: 'PHONE_INVALID',
            });
        }
        return result;
    }, []);
}
exports.getPhoneValidationErrors = getPhoneValidationErrors;
function normalisePhoneNumber(phoneNumber) {
    if (phoneNumber.indexOf('00') === 0) {
        return "+".concat(phoneNumber.substr(2));
    }
    if (phoneNumber.indexOf('0') === 0) {
        return "+44".concat(phoneNumber.substr(1));
    }
    return phoneNumber;
}
exports.normalisePhoneNumber = normalisePhoneNumber;
